import { ReactNode, lazy, Suspense } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AutoSEO } from "./AutoSEO";

const CookieConsent = lazy(() => import("./CookieConsent").then(m => ({ default: m.CookieConsent })));

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-20 focus:left-4 focus:z-[60] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md">
        Skip to main content
      </a>
      <AutoSEO />
      <Navbar />
      <main
        id="main-content"
        className="flex-1 pt-16"
        role="main"
      >
        {children}
      </main>
      <Footer />
      <Suspense fallback={null}>
        <CookieConsent />
      </Suspense>
    </div>
  );
}
